<template>
  <div class="allUser">
    <el-form
      size="medium"
      :inline="true"
      :model="queryForm"
      ref="queryForm"
      class="input-form-inline"
      @submit.native.prevent
    >
      <div>
        <el-form-item class="r-20" prop="user">
          <el-input
            v-model="queryForm.user"
            @keyup.enter.native="query"
            placeholder="请输入用户名"
          ></el-input>
        </el-form-item>
        <el-button v-if="hasPerm('sys:user:list')" type="primary" @click="query"
          >查询</el-button
        >
        <el-button v-if="hasPerm('sys:user:list')" @click="reset"
          >取消</el-button
        >
      </div>

      <div style="margin-bottom: 20px">
        <el-button
          v-if="hasPerm('sys:user:save')"
          type="primary"
          @click="addUser"
          >新增</el-button
        >
        <el-button
          size="medium"
          v-if="hasPerm('sys:user:delete')"
          type="danger"
          @click="delUser"
          >删除</el-button
        >
      </div>
    </el-form>
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      size="mini"
      stripe
      height="560px"
      @row-click="handleClickTableRow"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="24"
        align="center"
        style="padding: 0"
      ></el-table-column>
      <el-table-column type="index" label="序号" width="55"></el-table-column>
      <el-table-column
        prop="username"
        label="用户名"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="fullName"
        label="姓名"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="deptName" label="部门"></el-table-column>
      <el-table-column prop="postName" label="岗位"></el-table-column>
      <el-table-column prop="roleName" label="角色"></el-table-column>
      <el-table-column prop="mobile" label="联系电话"></el-table-column>
      <el-table-column
        prop="email"
        label="邮箱"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="操作" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            v-if="hasPerm('sys:user:update')"
            @click.stop="editUser(scope.row)"
            >修改</el-button
          >
          <!-- <el-button
            size="mini"
            type="text"
            v-if="
              hasPerm('sys:user:delete') && nowUserName != scope.row.username
            "
            @click.stop="delUser(scope.row)"
            >删除</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="allUser-pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="limit"
      layout="total, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
    <!--新增用户对话框-->
    <el-dialog :title="dialogTitle" :visible.sync="visible" class="mini-dialog">
      <el-form
        :rules="rules"
        ref="addUser"
        :model="UserForm"
        size="mini"
        :inline="true"
      >
        <el-form-item prop="username" label="用户名">
          <el-input
            v-model="UserForm.username"
            placeholder=""
            :disabled="editTag"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password" label="密码">
          <el-input
            v-model="UserForm.password"
            placeholder="请输入密码"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item prop="fullName" label="姓名">
          <el-input
            v-model="UserForm.fullName"
            placeholder="请输入姓名"
          ></el-input>
        </el-form-item>
        <el-form-item prop="mobile" label="电话">
          <el-input
            v-model="UserForm.mobile"
            placeholder="请输入电话号码"
          ></el-input>
        </el-form-item>
        <el-form-item prop="email" label="邮箱">
          <el-input
            v-model="UserForm.email"
            placeholder="请输入邮箱"
          ></el-input>
        </el-form-item>
        <el-form-item prop="roleId" label="角色">
          <el-select
            v-model="UserForm.roleId"
            clearable
            placeholder="请选择角色"
          >
            <el-option
              v-for="item in roleList"
              :key="item.roleId"
              :label="item.roleName"
              :value="item.roleId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="type" label="类型">
          <el-select v-model="UserForm.type" placeholder="请选择类型">
            <el-option
              v-for="item in typeList"
              :key="item.typeId"
              :label="item.typeName"
              :value="item.typeId"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="saveOrUpdate">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "UserList",
  data() {
    return {
      queryForm: {
        user: "",
      },
      UserForm: {
        username: "",
        password: "",
        fullName: "",
        mobile: "",
        email: "",
        roleId: "",
        type: "",
      },
      rules: {
        username: [
          {
            required: true,
            trigger: "change",
            message: "请输入用户名称",
          },
        ],
        mobile: [
          {
            pattern: this.$formRules.phone,
            required: false,
            trigger: "blur",
            message: this.$formRules.phoneMsg,
          },
        ],
        email: [
          {
            pattern: this.$formRules.email,
            required: false,
            trigger: "blur",
            message: this.$formRules.emailMsg,
          },
        ],
        password: [
          {
            required: false,
            trigger: "change",
            message: "请输入密码",
          },
        ],
        fullName: [
          {
            required: true,
            trigger: "change",
            message: "请输入姓名",
          },
        ],
        type: [
          {
            required: true,
            trigger: "change",
            message: "请选择类型",
          },
        ],
      },
      roleList: [],
      typeList: [
        {
          typeId: 1,
          typeName: "系统",
        },
        {
          typeId: 2,
          typeName: "客户",
        },
        {
          typeId: 3,
          typeName: "用户",
        },
      ],
      currentPage: 1,
      limit: 10,
      total: 0,
      // tableHeight: 0,
      tableData: [],
      tableVal: [],
      dialogTitle: "",
      visible: false,
      editTag: false,
      nowUserName: "",
    };
  },
  created() {
    this.nowUserName = sessionStorage.getItem("user");
    this.getUserList();
    this.getroleList();
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.tableHeight = window.innerHeight - 400; //后面的50：根据需求空出的高度，自行调整
    // });
  },
  methods: {
    async getUserList() {
      let obj = {};
      obj.username = this.queryForm.user;
      obj.limit = this.limit;
      obj.page = this.currentPage;
      let _this = this;
      let { data: res } = await _this.$axios.get("/api/sys/user/list", {
        params: obj,
      });
      if (res.code == 1) {
        _this.tableData = res.data.list;
        _this.total = res.data.totalCount;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    query() {
      this.getUserList();
    },
    reset() {
      this.$resetForm(this, "queryForm");
      this.getUserList();
    },
    addUser() {
      this.editTag = false;
      //清空表单数据
      this.$resetForm(this, "addUser");
      //设置弹框标题
      this.dialogTitle = "新增用户";
      this.rules.password[0].required = true;
      this.getroleList();
      //显示弹框
      this.visible = true;
    },
    editUser(row) {
      this.editTag = true;
      //清空表单数据
      this.$resetForm(this, "addUser");
      //设置弹框标题
      this.dialogTitle = "编辑用户";
      this.rules.password[0].required = false;
      this.getroleList();
      //显示弹框
      this.visible = true;
      //显示需要编辑的数据
      this.getUserInfo(row.id);
    },
    saveOrUpdate() {
      let _this = this;
      let data = [];
      _this.$refs.addUser.validate(async (valid) => {
        if (valid) {
          if (!_this.editTag) {
            data = await _this.$axios.post("/api/sys/user", _this.UserForm);
          } else {
            data = await _this.$axios.patch("/api/sys/user", _this.UserForm);
          }
          let res = data.data;
          if (res.code == 1) {
            //信息提示
            _this.$message.success("操作成功");
            //刷新表格
            _this.getUserList();
            _this.visible = false;
          } else {
            _this.$message.warning(res.msg);
          }
        }
      });
    },
    async delUser() {
      let _this = this;
      //多选删除
      let userIds = _this.$getIds(_this.tableVal);
      // let userIds = [row.id];
      if (!userIds) {
        return;
      }
      _this
        .$confirm("确定删除吗？", "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "waring",
        })
        .then(async () => {
          let { data: res } = await _this.$axios.delete("/api/sys/user", {
            data: JSON.stringify(userIds),
          });
          if (res.code == 1) {
            _this.$message.success("操作成功");
            let totalPage = Math.ceil((_this.total - 1) / 10);
            let currentPage =
              _this.currentPage > totalPage ? totalPage : _this.currentPage;
            _this.currentPage = currentPage < 1 ? 1 : currentPage;
            _this.getUserList();
          } else {
            _this.$message.warning(res.msg);
          }
        });
    },
    //选择数据变化监控
    handleSelectionChange(val) {
      this.tableVal = val;
    },
    handleClickTableRow(row, event, column) {
      console.log(row);
      console.log(column);
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    //pagesize改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    //页数改变时触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getUserList();
    },
    async getroleList() {
      let _this = this;
      let { data: res } = await _this.$axios.get("/api/sys/role/options");
      if (res.code == 1) {
        _this.roleList = res.data;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    async getUserInfo(id) {
      let _this = this;
      let { data: res } = await _this.$axios.get("/api/sys/user/" + id);
      if (res.code == 1) {
        _this.UserForm = res.data;
      } else {
        _this.$message.warning(res.msg);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.allUser {
  padding: 0 20px;
  .allUser-pagination {
    margin-top: 10px;
  }
}
</style>
